import { combineReducers } from 'redux';
import kioskReducer2 from './kiosk/reducer';
const appReducer = combineReducers({
    kioskReducer2
});
const rootReducer = (state, action) => {
    return appReducer(state, action)
}
export default rootReducer;